import React from 'react';

class MMSComponents  extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        require('../../common/mweb/css/index.css');
    }

    render() {
        return (
            <div className="park-wrap mms-groc-wrap">
                <div className="content-wrap">
                    <div className="contents">
                        <div className="info">
                            <div className="img-wrap">
                                <div className="img"><img
                                    src="https://asset.981park.com/www/common/mweb/img/mms/mms2026-cover-img.png"
                                    alt=""/></div>
                            </div>
                        </div>

                        <div className="info">
                            <div className="txt-wrap wh-area">
                                <div className="inner">
                                    <p className="ttl typo1">GROC 2026 Championship Final</p>
                                    <div className="txt">
                                        <p><b>"모든 것이 완벽하게 맞물리는 순간, 세상은 느려지고</b></p>
                                        <p><b>오직 가야 할 완벽한 라인만 보입니다."</b></p>
                                        <p><b><i>— Lewis Hamilton</i></b></p><br/>

                                        <p>바람을 가르는 소리와 트랙의 마찰만이 존재하는 곳.</p>
                                        <p>남은 것은 오직 중력의 법칙과</p>
                                        <p>스티어링 휠을 쥔 당신의 예리한 감각뿐입니다.</p><br/>

                                        <p>GROC는 지구의 중력가속도(g=9.81m/s²)를 마주하며</p>
                                        <p>자연적인 속도의 한계를 끊임없이 깨뜨려 온</p>
                                        <p>세계 유일의 그래비티 레이싱 챔피언십입니다.</p><br/>

                                        <p>수많은 코너와 0.001초의 찰나 속에서</p>
                                        <p>마침내 '한계 너머'를 증명해 낸 최정예 마스터 레이서.</p><br/>

                                        <p>예술적인 주행감각으로,</p>
                                        <p>완벽한 라인을 그리며 영원한 전설로 남을</p>
                                        <p>2026 GROC Championship Final의 무대로</p>
                                        <p>당신을 초대합니다.</p>
                                    </div>
                                    <div className="btn-area">
                                        <a href="https://youtu.be/KGg9KRAsLYw?si=Xn9xkVxWQthxktB1" target="_blank"
                                           rel="noopener noreferrer"
                                           className="btn"><span className="txt">전년도 대회 영상 보러가기 ></span></a>

                                    </div>
                                </div>
                                <div className="img-wrap">
                                    <div className="img"><img
                                        src="https://asset.981park.com/www/common/mweb/img/mms/img-2.svg" alt=""/></div>
                                </div>
                            </div>
                        </div>

                        <div className="info">
                            <div className="inner">
                                <div className="txt-wrap">
                                    <p className="ttl">대회 안내</p>
                                    <div className="txt">
                                        <p><b>일시</b> <span className="bar">|</span> 2026년 12월 6일 (일), 09:00 ~ 16:30</p>
                                        <p><b>장소</b> <span className="bar">|</span> 9.81파크 제주</p>
                                        <p className="text-indent-63"><b>경기 방식</b> <span
                                            className="bar">|</span> SINGLES(개인전) 1, 2차 주행</p>
                                        <p className="pl-70">TEAMS(팀전) 4강 / 결승</p>
                                    </div>
                                </div>

                                <div className="txt-wrap">
                                    <p className="ttl">참가 신청</p>
                                    <div className="txt">
                                        <p><b>1 ROUND ~ 9 ROUND 대상 참가 신청 마감일</b> |</p>
                                        <p>2026년 10월 28일 (수) 18:00까지</p>
                                    </div>
                                    <div className="btn-area">
                                        <a href="https://forms.gle/UBNhwPLtJmdRLTSd9" target="_blank" className="btn btn-pt-1"><span className="txt">대회 참가 신청하기 ></span></a>
                                    </div>
                                </div>
                                <div className="txt-wrap gold-txt">
                                    <p className="ttl lg-ttl">총 상금</p>
                                    <div className="img-wrap">
                                        <div className="img"><img src="https://asset.981park.com/www/common/mweb/img/mms/ttl-4.svg" alt=""/></div>
                                    </div>
                                    <div className="wh-table">
                                        <table>
                                            <tr>
                                                <th>
                                                    <span className="txt">SINGLES</span>
                                                </th>
                                                <th>
                                                    <span className="txt">TEAMS</span>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="txt-wrap">
                                                        <p className="txt">1등 : 300만원</p>
                                                        <p className="txt pl-30">+ Champion 자켓</p>
                                                        <p className="txt pl-30">+ 골든 플레이트</p>
                                                        <p className="txt">2등 : 150만원</p>
                                                        <p className="txt">3등 : 100만원</p>
                                                        <p className="txt">4등 부터 순위에 따라<br/>차등 지급</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="txt-wrap">
                                                        <p className="txt">1등 : 150만원</p>
                                                        <p className="txt">2등 : 100만원</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div className="ps-txt">
                                        <p>*총 상금은 Singles 와 Teams 지급 합산 금액입니다.</p>
                                        <p>*상금은 시상식 종료 후 본인 서명하에 지급되오니<br/>마지막까지 자리를 지켜주시기 바랍니다.</p>
                                        <p>*개인전 실격 Finalist 및 팀전 예선 탈락팀에게는<br/>소정의 참가비가 지급됩니다.<br/>개인전 실격 : 10만원 / 팀전
                                            예선 탈락팀 : 40만원</p>
                                        <p>*상금은 제세공과금 제외 후 지급됩니다.</p>
                                    </div>
                                </div>

                            {/*    <div className="txt-wrap">*/}
                            {/*        <p className="ttl">대회 일정</p>*/}
                            {/*        <div className="time-table">*/}
                            {/*            <table>*/}
                            {/*                <tr>*/}
                            {/*                    <th><span className="blind">내용없음</span></th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="date">2025년 12월 7일 (일)</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">9:00</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">리셉션 오픈:<br/>Finalist & Teams 등록 시작</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">10:20</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">리셉션 마감: Finalist & Teams<br/>등록 및 물품 보관 마감</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">10:30</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">개회식 및 선수 선언식</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">10:50</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">*/}
                            {/*                            레드카펫 세리머니, 오피셜 포토 촬영 <br/>*/}
                            {/*                            <span*/}
                            {/*                                className="ps-txt">팀전 참가 인원 우선 진행 <br/> 이후 개인전 조별 순서로 진행</span>*/}
                            {/*                        </p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">11:00 ~ 11:20</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">TEAMS 예선</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">11:30 ~ 12:20</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">SINGLES 1차 주행: Finalist 전원</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">11:20 ~ 13:30</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">점심시간</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">13:50 ~ 14:30</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">SINGLES 2차 주행: 1차&nbsp;&nbsp; ~ 21위</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">14:30 ~ 14:50</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">TEAMS 결승</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">14:50 ~ 15:20</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">SINGLES 2차 주행: 1차 1 ~ 20위</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">15:30</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">시상식 및 폐회식</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                <tr>*/}
                            {/*                    <th>*/}
                            {/*                        <p className="time">16:20</p>*/}
                            {/*                    </th>*/}
                            {/*                    <td>*/}
                            {/*                        <p className="txt">대회 종료 및 상금 수령</p>*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*            </table>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            </div>

                            <div className="inner wh-area">
                                <p className="ttl box-ttl">프로그램 및 혜택 안내</p>

                                <div className="txt-wrap">
                                    <p className="ttl">연습 레이스</p>

                                    <div className="txt">
                                        <p>• 대회 하루 전 XL, XR 각 1회 연습 가능</p>
                                        <p>• 쿠폰 지급 : 12/5 (토) 오전 9시. 9.81 파크 앱에서 확인</p>
                                    </div>
                                </div>

                                <div className="txt-wrap">
                                    <p className="ttl">리셉션 & 선수 등록 (B1F)</p>

                                    <div className="dt-txt">
                                        <p>권장 도착 시간 : 오전 9시</p>
                                        <p>등록 마감 시간 : 오전 10시 20분</p>
                                        <p>지참물 : 신분증 및 9.81 파크 앱이 설치된<br/> 본인 명의 휴대폰</p>
                                    </div>
                                    <div className="img-wrap">
                                        <div className="label"><span className="txt">B1F 출입구</span></div>
                                        <div className="img"><img src="https://asset.981park.com/www/common/mweb/img/mms/map-3.svg" alt=""/></div>
                                    </div>
                                    <div className="dt-txt">

                                    </div>
                                    <div className="txt">
                                        <p><b>등록 시 수령 혜택</b></p>
                                    </div>
                                    <div className="dt-txt">
                                        <p>리셉션 수령 : 네임 카드, 선수 전용 티켓,<br/>
                                            동반 1인 전용 티켓</p>
                                        <p>앱 쿠폰 수령 : 점심 식사 쿠폰 (동반자 1인 포함),<br/>레이스981 50% 할인쿠폰 10매 (대회 종료 후 지급)</p>
                                        <p>미등록 시 대회 참가 불가 (등록 마감 전 반드시 리셉션(B1F)에서 등록) *신분증 지참 필수</p>
                                    </div>
                                </div>

                                <div className="txt-wrap">
                                    <p className="ttl">웰컴패키지 & 선수 전용 물품보관함 (B2F)</p>

                                    <div className="dt-txt">
                                        <p>SINGLES / TEAMS 각각 전용 웰컴 패키지 지급</p>
                                        <p>선수 전용 물품 보관함 이용 (네임카드 착용 필수)</p>
                                    </div>
                                    <div className="img-wrap">
                                        <div className="label"><span className="txt">B2F 센트럴</span></div>
                                        <div className="img"><img src="https://asset.981park.com/www/common/mweb/img/mms/map-2.svg" alt=""/></div>
                                    </div>
                                    <div className="txt">
                                        <p><b>패키지 구성</b></p>
                                    </div>
                                    <div className="dt-txt">
                                        <p>SINGLES : 네임카드를 포함한 개인전 전용 아이템</p>
                                        <p>TEAMS : 팀 대표 컬러를 담은 팀전 전용 아이템</p>
                                    </div>
                                </div>

                                <div className="txt-wrap">
                                    <p className="ttl">9.81 인천공항 혜택 증정</p>
                                    <div className="dt-txt">
                                        <p>2027년 봄 오픈 예정인 '9.81 인천공항'에서<br/>
                                        누릴 수 있는 특별한 혜택 제공 예정</p>
                                        <p>혜택 내용 : 2026년 11월 오픈 예정</p><br/>
                                    </div>
                                    <div className="img-wrap">
                                        <div className="img"><img src="https://asset.981park.com/www/common/mweb/img/mms/icn_image.png" alt=""/></div>
                                    </div>
                                    <div className="txt">
                                        <br/>
                                        <p><b>9.81 인천공항이란?</b></p>
                                    </div>
                                    <div className="dt-txt">
                                        <p>인천국제공항 제1여객터미널에서 5분 거리에 위치한<br/>
                                        9.81의 두 번째 플랫폼으로, 도심 환경에 맞게 설계한<br/>
                                        인도어형 테마파크</p>
                                        <p>2027년 개편될 '라이센스' 및 '챔피언십 파이널'규정에<br/>
                                        대한 안내와 함께 9.81 인천공항의 차세대 플랫폼을<br/>
                                        한발 먼저 경험할 수 있는 혜택 제공 예정</p>
                                    </div>
                                </div>

                                <div className="txt-wrap">
                                    <p className="ttl">대회 규정 및 유의사항</p>
                                    <div className="dt-txt">
                                        <p>규정집 공개 예정 : 2026년 11월 확인 가능<br/>
                                            (별도 공지 없이 업데이트될 수 있음)</p>
                                        <p>대회 당일 현장 상황(기상 등)에 따라 일정 변경 가능,<br/>
                                        변동 시 별도 안내 예정</p>
                                    </div>
                                </div>

                                {/*<div className="txt-wrap">*/}
                                {/*    <p className="ttl">개회식 & 전체 선수 선언식</p>*/}
                                {/*    <div className="txt">*/}
                                {/*        <p>개회식 및 전체 선수 선언식, 단체 사진 촬영 참석 필수</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="txt-wrap">*/}
                                {/*    <p className="ttl">레드카펫 & 오피셜 포토</p>*/}
                                {/*    <div className="txt">*/}
                                {/*        <p>패독 입장 전, 직접 선정한 BGM에 맞춰 레드카펫<br/>*/}
                                {/*            세리머니 진행</p>*/}
                                {/*        <p>패독 입장 후, 오피셜 포토 촬영 진행</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="txt-wrap">*/}
                                {/*    <p className="ttl">점심 식사</p>*/}
                                {/*    <div className="txt">*/}
                                {/*        <p><b>시간</b> <span className="bar">|</span> 11:30 ~ 13:30 (조별 식사 시간 맞춰 이용)</p>*/}
                                {/*        <p><b>위치</b> <span className="bar">|</span> 1층 챔피언 라운지<br/>*/}
                                {/*            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(입구*/}
                                {/*            옆 하늘그네 방향 계단 이용)</p>*/}
                                {/*    </div>*/}
                                {/*    <div className="dt-txt">*/}
                                {/*        <p>조별 식사 시간</p>*/}
                                {/*    </div>*/}
                                {/*    <div className="wh-table">*/}
                                {/*        <table>*/}
                                {/*            <tr>*/}
                                {/*                <td>*/}
                                {/*                    <span className="ttl">A / B 조</span>*/}
                                {/*                    <span className="txt">11:40 ~</span>*/}
                                {/*                </td>*/}
                                {/*                <td>*/}
                                {/*                    <span className="ttl">C / D 조</span>*/}
                                {/*                    <span className="txt">11:50 ~</span>*/}
                                {/*                </td>*/}
                                {/*            </tr>*/}
                                {/*            <tr>*/}
                                {/*                <td>*/}
                                {/*                    <span className="ttl">E / F 조</span>*/}
                                {/*                    <span className="txt">12:00 ~</span>*/}
                                {/*                </td>*/}
                                {/*                <td>*/}
                                {/*                    <span className="ttl">G / H 조</span>*/}
                                {/*                    <span className="txt">12:10 ~</span>*/}
                                {/*                </td>*/}
                                {/*            </tr>*/}
                                {/*            <tr>*/}
                                {/*                <td>*/}
                                {/*                    <span className="ttl">I / J 조</span>*/}
                                {/*                    <span className="txt">12:20 ~</span>*/}
                                {/*                </td>*/}
                                {/*                <td style={{ borderLeft: 'none' }}>*/}
                                {/*                </td>*/}
                                {/*            </tr>*/}
                                {/*            <tr>*/}
                                {/*                <td>*/}
                                {/*                    <span className="ttl">Teams만 참가하는 경우 :</span>*/}
                                {/*                </td>*/}
                                {/*                <td style={{ borderLeft: 'none' }}>*/}
                                {/*                    <span className="txt"> 11:20 ~</span>*/}
                                {/*                </td>*/}
                                {/*            </tr>*/}
                                {/*        </table>*/}
                                {/*    </div>*/}
                                {/*    <div className="dt-txt">*/}
                                {/*        <p>원활한 식사를 위해 조별 식사 시간을 지켜주세요.</p>*/}
                                {/*        <p>리셉션에서 Finalist/Teams 등록 시 동반 1인을<br/>*/}
                                {/*            포함한 앱 쿠폰이 발급됩니다.</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="txt-wrap">*/}
                                {/*    <p className="ttl">이벤트</p>*/}
                                {/*    <div className="txt">*/}
                                {/*        <p>당일 현장에서 공개되는 이벤트 성공 시 9.81파크의<br/>*/}
                                {/*            브랜드 스토어 SpaceCup의 인기 굿즈가 제공됩니다.</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="txt-wrap">*/}
                                {/*    <p className="ttl">Finalist/Teams 현장 인터뷰 (필수 대상)</p>*/}
                                {/*    <div className="dt-txt">*/}
                                {/*        <p>TEAMS : 점심시간 종료 후, 결승 진출팀 전체 </p>*/}
                                {/*        <p>SINGLES : 2차 주행 후, 실시간 랭킹 1위</p>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        {/*<div className="info">*/}
                        {/*    <div className="inner">*/}
                        {/*        <div className="txt-wrap">*/}
                        {/*            <p className="ttl">대회 규정 및 유의사항</p>*/}
                        {/*            <div className="dt-txt">*/}
                        {/*                <p>*/}
                        {/*                    GROC 2025 챔피언십 파이널 규정집은 11월 12일 <br/>*/}
                        {/*                    부터 확인 가능하며, 별도의 공지 없이 업데이트 될 수 <br/>*/}
                        {/*                    있습니다.*/}
                        {/*                </p>*/}
                        {/*                <p>*/}
                        {/*                    대회 당일 현장 상황(기상 등)에 의해 세부 일정은 <br/>*/}
                        {/*                    변경될 수 있으며, 변동 시 별도 안내 예정입니다.*/}
                        {/*                </p>*/}
                        {/*                <p>*/}
                        {/*                    이번 대회부터 GR-X에 요크형 핸들이 장착되며, <br/>*/}
                        {/*                    부스터 미션 조건이 변경됩니다.<br/>*/}
                        {/*                    대회 규정집을 반드시 읽어주시기 바랍니다.*/}
                        {/*                </p>*/}
                        {/*            </div>*/}
                        {/*            <div className="btn-area">*/}
                        {/*                <a href="https://asset.981park.com/www/common/web/img/pdf/GROC-2025-Championship-Final-Rule.pdf"*/}
                        {/*                   target="_blank" className="btn"><span className="txt">대회 규정 바로가기 ></span></a>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MMSComponents;

